module.exports = __webpack_public_path__ + "static/img/arrowLeft.58c8ebca.png";